'use strict';

import _ from 'lodash';
import alt from '../alt';
import {createStore, datasource, bind} from 'alt/utils/decorators';
import ConferenceActions from '../actions/conference.actions';
import ConferenceSource from '../sources/conference.source';

@createStore(alt)
@datasource(ConferenceSource)
class ConferenceStore {

  constructor() {
    this.current   = {};
  }

  // fetch individual conference
  @bind(ConferenceActions.load)
  onLoad(props) {
    if (!this.getInstance().isLoading()) {
      this.getInstance().fetch(props);
    }
  }

  @bind(ConferenceActions.loaded)
  onLoaded(result) {
    this.current                   = result ? result[0] : [];
    this.current.cities            = _(this.current.locations).sortBy('start').values().value();
    this.current.hasAdvisoryBoard  = !!_(this.current.speakers).find({ advisory_board: true });
    this.current.hasExhibitors     = !!_(this.current.sponsors).find({ level: 'exhibitor' });
    this.current.hasResources      = !!(this.current.white_papers || this.current.supplements);
    this.current.hasSpeakers       = !!this.current.speakers;
    this.current.speakers          = sortSpeakers(this.current.speakers);
    this.current.hasSponsors       = !!this.current.sponsors;
    this.current.hasPartners       = !!this.current.partners;
    this.current.hasVenue          = (findLocations(this.current.cities) || (this.current.venue && this.current.venue.html));
    this.current.hasSafetyProtocols = !!this.current.safety_html;
    this.current.hasCustomContent  = !!this.current.custom_content;
    this.current.hasMultimedia     = this.current.media && this.current.media.slideshows || this.current.media && this.current.media.video_html;
    this.current.hasLiveStream     = this.current.live_stream && this.current.live_stream.livestream_promo &&
                                     (this.current.live_stream.livestream_promo !== 'none' && this.current.live_stream.livestream_promo !== '');

    function findLocations(cities){
      for(var k in cities){
        if(cities[k]['venue'] !== ''){
          return true;
        }
      }
      // If none of the locations have a venue, hide the Venue nav tab
      return false;
    }

    function sortSpeakers(speakers){
      return _(speakers).sortBy((speaker) => {
        var names = speaker.name.trim().split(' ');
        var nameLength = names.length;
        var lastName = nameLength - 1;
        for (var i = 0; i < nameLength; i++) {
          if (names[i].indexOf('.') != -1) {
            if (i == lastName) {
              names.pop();
            }
            else if (i == 0) {
              names[1] = '';
              i++;
            }
            else {
              names[i] = '';
            }
          }
          if (i == lastName) {
            if ((names[i] == 'II') || (names[i] == 'III') || (names[i] == 'IV')) {
              names.splice(i, 1);
            }
          }
        }
        return _.last(names);
      }).value();
    }
    
  }
}

export default ConferenceStore;
